import React from 'react';
const RADIAN = Math.PI / 180;

const CustomLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.7;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  return /*#__PURE__*/React.createElement("text", {
    x: x,
    y: y,
    fill: "white",
    style: {
      fontSize: 13,
      fontWeight: 500
    },
    textAnchor: "middle",
    dominantBaseline: "center"
  }, `${(percent * 100).toFixed(0)}%`);
};

export default CustomLabel;